// US metro cost index vs national average (1.00). Mirrors backend csi_catalog.location_multiplier.
export const CITY_INDEX = {
  "manhattan": 1.40, "new york": 1.35, "brooklyn": 1.30,
  "san francisco": 1.38, "san jose": 1.32, "oakland": 1.30,
  "los angeles": 1.20, "san diego": 1.15, "sacramento": 1.10,
  "seattle": 1.22, "portland": 1.12, "boston": 1.28, "chicago": 1.18,
  "washington": 1.20, "philadelphia": 1.15, "denver": 1.08,
  "austin": 1.02, "dallas": 0.98, "houston": 0.96, "san antonio": 0.94,
  "phoenix": 1.00, "las vegas": 1.05, "miami": 1.06, "orlando": 0.95,
  "tampa": 0.94, "atlanta": 0.95, "charlotte": 0.92, "nashville": 0.96,
  "minneapolis": 1.10, "detroit": 1.02, "cleveland": 1.00, "columbus": 0.96,
  "kansas city": 0.97, "st louis": 0.98, "salt lake city": 1.00,
  "honolulu": 1.35, "anchorage": 1.25,
};

export const STATE_INDEX = {
  ny: 1.25, ca: 1.18, wa: 1.15, ma: 1.22, hi: 1.30, ak: 1.22, nj: 1.18,
  ct: 1.18, il: 1.10, dc: 1.20, or: 1.08, md: 1.10, co: 1.05, mn: 1.05,
  pa: 1.05, mi: 1.00, oh: 0.98, va: 0.98, tx: 0.96, fl: 0.96, ga: 0.94,
  nc: 0.92, tn: 0.94, az: 1.00, nv: 1.02, mo: 0.95, ut: 1.00, wi: 1.00,
  in: 0.96, sc: 0.92, al: 0.90, ms: 0.89, ar: 0.89, ok: 0.90, ks: 0.94,
  ne: 0.94, la: 0.92, ky: 0.93, nm: 0.95,
};

// Searchable preset list of major US metros with their state + multiplier.
export const US_METROS = [
  ["New York, NY", 1.35], ["Brooklyn, NY", 1.30], ["San Francisco, CA", 1.38],
  ["San Jose, CA", 1.32], ["Oakland, CA", 1.30], ["Los Angeles, CA", 1.20],
  ["San Diego, CA", 1.15], ["Sacramento, CA", 1.10], ["Seattle, WA", 1.22],
  ["Portland, OR", 1.12], ["Boston, MA", 1.28], ["Chicago, IL", 1.18],
  ["Washington, DC", 1.20], ["Philadelphia, PA", 1.15], ["Denver, CO", 1.08],
  ["Austin, TX", 1.02], ["Dallas, TX", 0.98], ["Houston, TX", 0.96],
  ["San Antonio, TX", 0.94], ["Phoenix, AZ", 1.00], ["Las Vegas, NV", 1.05],
  ["Miami, FL", 1.06], ["Orlando, FL", 0.95], ["Tampa, FL", 0.94],
  ["Atlanta, GA", 0.95], ["Charlotte, NC", 0.92], ["Nashville, TN", 0.96],
  ["Minneapolis, MN", 1.10], ["Detroit, MI", 1.02], ["Cleveland, OH", 1.00],
  ["Columbus, OH", 0.96], ["Kansas City, MO", 0.97], ["St. Louis, MO", 0.98],
  ["Salt Lake City, UT", 1.00], ["Honolulu, HI", 1.35], ["Anchorage, AK", 1.25],
].map(([label, mult]) => ({ label, mult }));

// Same matching order as the backend: city substring first, then state token.
export function regionMultiplier(location) {
  if (!location) return 1.0;
  const loc = location.toLowerCase();
  for (const [city, mult] of Object.entries(CITY_INDEX)) {
    if (loc.includes(city)) return mult;
  }
  for (const tok of loc.split(/[,\s]+/)) {
    if (STATE_INDEX[tok] !== undefined) return STATE_INDEX[tok];
  }
  return 1.0;
}

// Human-readable adjustment label for the cost-index badge.
export function regionIndexLabel(location) {
  const mult = regionMultiplier(location);
  const pct = Math.round((mult - 1) * 100);
  if (!location) return { text: "US average rates", pct: 0, mult };
  if (pct === 0) return { text: "Local rates at US average", pct: 0, mult };
  const dir = pct > 0 ? "above" : "below";
  return { text: `Local rates ~${Math.abs(pct)}% ${dir} US avg`, pct, mult };
}
